/**
 * Token axios instance.
 * Used for refreshing api tokens.
 */

import { API_URL } from '@pequity/shared/utils/api-url';
import axios from 'axios';

export const tokenInstance = axios.create({
  baseURL: API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});
